import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import { Substitution } from '@barboxx/models';
import { FLAVOR_TYPES } from '@barboxx/types';
import { enumToFormOptions } from '@barboxx/utils';

const COLUMNS: GridColDef<Substitution>[] = [
    { field: 'id', headerName: 'Id', width: 70 },
    { field: 'name', headerName: 'Name', width: 200, flex: 1 },
    { field: 'targetType', headerName: 'Target Type', width: 150 },
    {
        field: 'targetFlavor',
        headerName: 'Target Flavor',
        type: 'singleSelect',
        valueOptions: enumToFormOptions(FLAVOR_TYPES),
        width: 200,
    },
    {
        field: 'substitutionType',
        headerName: 'Substitution Type',
        width: 150,
    },
    {
        field: 'substitutionFlavor',
        headerName: 'Substitution Flavor',
        type: 'singleSelect',
        valueOptions: enumToFormOptions(FLAVOR_TYPES),
        width: 200,
    },
];

interface Props {
    data: Substitution[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function SubstitutionTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <DataGridCard title="Substitutions">
            <DataGrid
                rows={data}
                columns={COLUMNS}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
